import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class CmsHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
